import { Box } from "@mui/material";
import { SITE_MEDIA } from "src/domains/shared/constants/styles/site";

/** 한 바퀴 시간 — 움직임 줄이기에서는 멈추지 않고 두 배로 느리게 돈다(진행 표시는 꼭 필요한 움직임이다) */
const SPIN_SECONDS = 0.8;
const REDUCED_MOTION_SPIN_SECONDS = 1.6;
const RING_WIDTH_PX = 2;
/** 고리 지름 — 버튼 글자 크기를 따른다 */
const SPINNER_SIZE = "1em";

const SPINNER_STYLES = {
  position: "relative",
  flex: "none",
  display: "inline-block",
  width: SPINNER_SIZE,
  height: SPINNER_SIZE,
  boxSizing: "border-box",
  borderRadius: "50%",
  border: `${RING_WIDTH_PX}px solid transparent`,
  borderTopColor: "currentColor",
  animation: `siteButtonSpin ${SPIN_SECONDS}s linear infinite`,
  "@keyframes siteButtonSpin": { to: { transform: "rotate(360deg)" } },
  // 옅은 바탕 고리 — 글자색을 그대로 쓰고 불투명도로 흐린다(color-mix 를 못 읽는 브라우저에서 테두리째 사라지지 않게)
  "&::before": {
    content: '""',
    position: "absolute",
    inset: `-${RING_WIDTH_PX}px`,
    borderRadius: "50%",
    border: `${RING_WIDTH_PX}px solid currentColor`,
    opacity: 0.25,
  },
  // 사이트 전역 규칙(움직임 줄이기면 `[data-site] *` 애니메이션을 한 번만)보다 우선하도록 클래스를 두 번 건다
  [SITE_MEDIA.reducedMotion]: {
    "&&": {
      animationDuration: `${REDUCED_MOTION_SPIN_SECONDS}s !important`,
      animationIterationCount: "infinite !important",
    },
  },
} as const;

/**
 * 사이트 버튼 안의 진행 표시(marketing-auth-pages·marketing-site-shell) — 버튼 글자 앞에 두는 작은 고리다.
 * 색은 버튼 글자색, 크기는 글자 크기를 따른다. 장식이라 보조 기술에 읽히지 않으므로 버튼에 `aria-busy` 를 함께 단다.
 * transform 회전이라 로그인 계산으로 메인 스레드가 바빠도 멈추지 않는다.
 * 글자 폭으로 크기가 정해지는 버튼은 고리를 단 동안 좌우 여백을 `paddingInlineWithSpinner` 로 줄여 바깥 폭을 지킨다.
 */
export function SiteButtonSpinner() {
  return (
    <Box
      component="span"
      aria-hidden="true"
      data-site-spinner=""
      sx={SPINNER_STYLES}
    />
  );
}

/**
 * 고리를 단 동안의 좌우 여백 — 평소 여백(`paddingX`)에서 (고리 지름 + 고리·글자 간격 `gap`)의 절반씩을 빼서,
 * 진행 중에도 버튼 바깥 폭이 평소와 같다. 넓어지면 옆 요소(머리말 오른쪽 묶음·「중복확인」 옆 입력 칸)가 밀린다.
 */
export const paddingInlineWithSpinner = (paddingX: string, gap: string) =>
  `calc(${paddingX} - (${SPINNER_SIZE} + ${gap}) / 2)`;
